import React from "react";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Directory from "./components/Directory";
import RightBar from "./components/RightBar";

import { Fullpage, Slide } from 'fullpage-react';
import FullpageReact from "./logic/FullpageModified"


class App extends React.Component{

  render(){
    const activeSection = Fullpage.generateState;
    const screenHeight= window.screen.availHeight;
    const screenWidth = window.screen.availWidth;

    return (
      <div>
        <Header />

        <RightBar/ >
        <FullpageReact>
        </FullpageReact>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js